module.exports = __webpack_public_path__ + "img/unreal-engine.fc3e1efd.svg";